(() => {
  angular
    .module('finance')
    .controller('finance.views.integrationErrorLog.detailModal', IntegrationErrorLogDetailModalController);

  IntegrationErrorLogDetailModalController.$inject = ['$uibModalInstance', 'errorLog'];

  function IntegrationErrorLogDetailModalController($uibModalInstance, errorLog) {
    const vm = this;

    vm.errorLog = errorLog;
    vm.close = close;

    init();

    function init() {
      // Parse internal reference ID
      if (vm.errorLog.internalReferenceId && typeof vm.errorLog.internalReferenceId === 'string') {
        // Check if it's pipe-delimited format
        if (vm.errorLog.internalReferenceId.includes('|')) {
          const ids = vm.errorLog.internalReferenceId
            .split('|')
            .filter(id => id.trim() !== '');
          vm.errorLog.parsedInternalReference = ids.join('\n');
        } else {
          // Try to parse as JSON
          try {
            const parsed = JSON.parse(vm.errorLog.internalReferenceId);
            vm.errorLog.parsedInternalReference = JSON.stringify(parsed, null, 2);
          } catch (e) {
            vm.errorLog.parsedInternalReference = vm.errorLog.internalReferenceId;
          }
        }
      } else {
        vm.errorLog.parsedInternalReference = vm.errorLog.internalReferenceId;
      }

      try {
        if (vm.errorLog.errorDetails && typeof vm.errorLog.errorDetails === 'string') {
          vm.errorLog.parsedErrorDetails = JSON.parse(vm.errorLog.errorDetails);
        }
      } catch (e) {
        vm.errorLog.parsedErrorDetails = vm.errorLog.errorDetails;
      }
    }

    function close() {
      $uibModalInstance.dismiss();
    }
  }
})();
